var map = {
	"./About.vue": [
		"f820",
		"chunk-f92eaf1a"
	],
	"./Error.vue": [
		"dda8",
		"chunk-2d22996d"
	],
	"./GameOver.vue": [
		"29bf",
		"chunk-39925f6c"
	],
	"./Instructions.vue": [
		"dd5a",
		"chunk-b5aedf72"
	],
	"./Main.vue": [
		"cd56",
		"chunk-bca39262"
	],
	"./Questions.vue": [
		"66ba",
		"chunk-8107a0b6",
		"chunk-56c38700"
	],
	"./Select.vue": [
		"0494",
		"chunk-8107a0b6",
		"chunk-28724445"
	],
	"./Solve.vue": [
		"07c0",
		"chunk-8107a0b6",
		"chunk-34c2a03f"
	],
	"./Welcome.vue": [
		"eec5",
		"chunk-00bbe72b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;